export default __webpack_public_path__ + "static/media/limit.53a16258.svg";